<script lang="ts">
	import { tick, type Snippet } from "svelte"

	// basically the exact same as the collapsible section, but with 0 bindable props

	interface Props {
		expanded?: boolean
		title?: string
		className?: string
		header?: Snippet<[any]>
		content?: Snippet
		onclick?: (doExpand?: boolean) => void
	}

	let { expanded, title = undefined, className = "", header, content, onclick }: Props = $props()

	let contentHeight: number = $state()
	let contentContainer: HTMLDivElement = $state()
	let allowAnimation = $state(false)

	const resizeObserver = new ResizeObserver((entries) => {
		const entry = entries[0]
		updateContentHeight(entry.target as HTMLDivElement)
	})

	function updateContentHeight(div: HTMLDivElement) {
		contentHeight = div.offsetHeight
	}

	$inspect(contentHeight)

	function initializeResizeObserver(div: HTMLDivElement) {
		if (!div) return

		resizeObserver.observe(contentContainer)
	}

	$effect(() => {
		if (contentContainer) {
			updateContentHeight(contentContainer)
			initializeResizeObserver(contentContainer)
			setTimeout(() => {
				allowAnimation = true
			})
		}
	})
</script>

<div class="collapsible-section {className} {expanded ? 'section-expanded' : ''}" {title}>
	<div
		class="section-header"
		onclick={(e) => {
			e.stopPropagation()
			onclick?.(!expanded)
		}}
	>
		{@render header?.({ isExpanded: expanded })}
	</div>
	<div
		class="collapsible-section-body"
		class:animated={allowAnimation}
		style="height: {expanded ? contentHeight : 0}px;"
	>
		<div bind:this={contentContainer} class="content">
			{@render content?.()}
		</div>
	</div>
</div>

<style>
	.section-header {
		position: relative;
		width: 100%;
		display: flex;
		align-items: start;
	}

	.collapsible-section {
		position: relative;
		width: 100%;
	}

	.collapsible-section-body {
		position: relative;
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		width: 100%;
		overflow: hidden;
		height: 0px;
	}

	.collapsible-section-body.animated {
		transition: height var(--transition-duration) var(--transition-timing);
	}
</style>
